export const predefinedReasons = [
  {
    value: "Insufficient sample received",
    label: "Insufficient sample received",
  },
  {
    value: "Incorrect specimen received",
    label: "Incorrect specimen received",
  },
  { value: "Turnaround time", label: "Turnaround time" },
  {
    value: "Specimen received without requisition",
    label: "Specimen received without requisition",
  },
  { value: "Early collection", label: "Early collection" },
  {
    value: "Only requisition received without sample",
    label: "Only requisition received without sample",
  },
  {
    value: "Sample has leaked in transit",
    label: "Sample has leaked in transit",
  },
  {
    value: "Hemolyzed or clotted specimen",
    label: "Hemolyzed or clotted specimen",
  },
  { value: "Invalid insurance", label: "Invalid insurance" },
  {
    value: "Inactive insurance",
    label: "Inactive insurance",
  },
  {
    value: "Invalid ICD codes",
    label: "Invalid ICD codes",
  },
  {
    label: "The date of collection is missing in the requisition",
    value: "The date of collection is missing in the requisition",
  },
  {
    label: "ICD codes are missing in the requisition",
    value: "ICD codes are missing in the requisition.",
  },
  {
    value: "The test is not marked correctly",
    label: "The test is not marked correctly",
  },
  {
    value: "Specimen and test mismatch",
    label: "Specimen and test mismatch",
  },
  {
    value: "Medications are needed",
    label: "Medications are needed",
  },
  {
    value: "Insurance details are missing",
    label: "Insurance details are missing",
  },
  {
    value: "There is a billing mismatch",
    label: "There is a billing mismatch",
  },
  {
    value: "Others",
    label: "Others",
  },
  // Add more predefined reasons as needed
];

export const reasonToActionMap = {
  "Insufficient sample received":
    "Please provide a specimen with sufficient quantity for processing the test.",
  "Incorrect specimen received":
    "Please provide the correct specimen type related to the test ordered.",
  "Turnaround time":
    "Please minimize the time delay between specimen collection and specimen receipt.",
  "Specimen received without requisition":
    "Please provide the requisition form to process the testing.",
  "Only requisition received without sample":
    "Please provide the sample for test processing along with the updated requisition.",
  "Sample has leaked in transit":
    "Please provide a fresh sample to process the test.",
  "Hemolyzed or clotted specimen":
    "Please recollect the sample as it needs to be in proper condition for testing.",
  "Invalid insurance":
    "Please provide valid insurance details along with a copy of the insurance.",
  "Inactive insurance":
    "Please provide active insurance details along with a copy of the insurance.",
  "Invalid ICD codes":
    "Please provide valid ICD codes to process the test.",
  "The date of collection is missing in the requisition":
    "We need the date of collection to process the test.",
  "ICD codes are missing in the requisition":
    "Please provide the ICD code for test processing.",
  "The test is not marked correctly":
    "We need an updated requisition to process the testing.",
  "Specimen and test mismatch":
    "The specimen and requisition are incompatible.",
  "Medications are needed":
    "We require the medications for test processing.",
  "Insurance details are missing":
    "Please provide the insurance details and a copy of the insurance card.",
  "There is a billing mismatch":
    "The bill-to information is marked incorrectly.",
};

export default {
  predefinedReasons,
  reasonToActionMap,
};
